import { render, staticRenderFns } from "./ResetKey.vue?vue&type=template&id=d9c7d1e8&scoped=true&"
import script from "./ResetKey.vue?vue&type=script&lang=js&"
export * from "./ResetKey.vue?vue&type=script&lang=js&"
import style0 from "./ResetKey.vue?vue&type=style&index=0&id=d9c7d1e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9c7d1e8",
  null
  
)

export default component.exports